<template>
  <div :class="name">
    <backup-img
      :src="picture"
      class="item-img"
    />
    <div class="item-content">
      <div class="item-content__name">
        {{ title }}
      </div>
      <div class="item-content__id">
        {{ id }}
      </div>
    </div>
  </div>
</template>

<script>
import backupImg from '../../../common/back-img/index.vue';
import { defineComponent } from '@vue/composition-api';

const name = 'ttam-product-details-select-product-detail';
export default defineComponent({
  name,
  components: {
    backupImg,
  },
  props: {
    picture: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      name,
    };
  },
});
</script>

<style lang="scss">
$name: 'ttam-product-details-select-product-detail';
.#{$name} {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-top: 12px;
  padding-bottom: 12px;
  .item-img {
    flex: none;
    width: 68px;
    height: 68px;
    margin-right: 10px;
    border-radius: 4px;
    &.after-radio {
      margin-left: 20px;
    }
  }
  .item-content {
    flex: auto;
    line-height: 20px;
    .item-content__name {
      @extend %text-over-ellipsis-2line;
      margin-bottom: 12px;
      color: $--color-group3-0;
      font-weight: $font-weight-bold;
      word-break: normal;
    }
    .item-content__id {
      font-size: 12px;
      color: $--color-group3-2;
    }
  }
}
</style>
